export default __webpack_public_path__ + "fa95c709d2f180813cec11d1aed5a0ac.png";